module.exports = __webpack_public_path__ + "img/sanctuary-pic-large.d1cd4707.webp";